import React, { Component } from 'react';
import PreLoaderWidget from '../../../components/Loader';


import { Link } from 'react-router-dom'
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { Camera } from 'react-cam';
import Popover from 'react-awesome-popover';
// import "react-awesome-popover/build/index.css";

// import Camera from 'react-html5-camera-photo';
// import 'react-html5-camera-photo/build/css/index.css';


import Notificacao from '../../../components/Notificacao'
// import Imput from '../../../components/Input'
// import Loading from '../../../components/Loading';
// import Header from '../../../Components/Header'
import FileUploader from "react-firebase-file-uploader";
import Loader from '../../../components/Loader';
import {
    firebaseAuth,
    firebaseFire as Libfirebase,
    firebaseStorage
} from '../../../helpers/firebase-config';

import { setHistorico, atualizarEspecialidadesPaciente } from '../../../Libs/paciente';

import DropDownEspecialidade from '../../../components/DropDownEspecialidade'
// import ListStatus from '../../../Components/ListStatus';
//import { Row, Col, Card, CardBody } from 'reactstrap';
import { v4 as uuid } from 'uuid'
import moment from 'moment'
import './styles.scss';

export default class CadastrarHistorico extends Component {

    state = {
        loading: false,
        filenames: [],
        downloadURLs: [],
        isUploading: false,
        uploadProgress: 0,
        camera: false,
        id: null,
        Observacao: '',
        especialidade: '',
        queixa: '',
        exames: '',
        historico: '<p> Teve trauma? </p>'
    }

    componentDidMount = () => {
        const id = this.props.match && this.props.match.params.id ? this.props.match.params.id : this.props.id;
        this.setState({ id })
    }

    handleUploadStart = () =>
        this.setState({
            isUploading: true,
            uploadProgress: 0
        });

    handleProgress = progress =>
        this.setState({
            uploadProgress: progress
        });

    handleUploadError = error => {
        this.setState({
            isUploading: false
            // Todo: handle error
        });
        console.error(error);
    };

    handleUploadSuccess = async filename => {
        const downloadURL = await firebaseStorage
            .ref("images")
            .child(filename)
            .getDownloadURL();

        this.setState(oldState => ({
            filenames: [...oldState.filenames, filename],
            downloadURLs: [...oldState.downloadURLs, downloadURL],
            uploadProgress: 100,
            isUploading: false
        }));
    };

    capture = (imgSrc) => {

        const metadata = {
            contentType: 'data:image/jpeg;base64'
        };

        var that = this;

        var ref = firebaseStorage.ref("images")
        const name = uuid();
        ref.child(name).putString(imgSrc.split(',')[1], 'base64').then(snapshot => {

            ref.child(name).getDownloadURL().then(function (url) {
                that.setState({ downloadURLs: [...that.state.downloadURLs, url], camera: false })
            });

        })
    }


    deleteFoto = (downloadURL) => {
        let nome = downloadURL.split('/o/')[1].split('?')[0].replace('%2F', '/');
        const { downloadURLs } = this.state
        firebaseStorage.ref(nome).delete().then(() => {
            let index = downloadURLs.findIndex(x => x === downloadURL)
            if (index >= 0) {

                downloadURLs.splice(index, 1)

                this.setState({ downloadURLs })
            }
        })
            .catch(error => console.log(error))
    }

    _setCadastro = async () => {
        this.setState({ loading: true })
        const { downloadURLs, historico, queixa, Observacao, id, especialidade, exames } = this.state

        const user = firebaseAuth.currentUser

        if (especialidade !== '') {

            let idProfissional = 0

            await Libfirebase
                .collection('usuario')
                .where('email', '==', user.email)
                .get()
                .then(snap => {
                    snap.forEach(doc => {
                        if (doc.exists) {
                            idProfissional = doc.id
                        }
                        else {

                        }
                    })
                })
                .catch(erro => console.log(erro))

            const refProfissional = Libfirebase
                .collection('usuario')
                .doc(idProfissional)
            const data = {
                Observacao,
                DataCriacao: moment().format('DD-MM-YYYY'),
                Hora: moment().format('HH:mm:ss'),
                Date: new Date(),
                refProfissional,
                especialidade,
                historico,
                queixa,
                exames,
                status: 'Aguardando Análise'
            }
            setHistorico(data, id, downloadURLs).then(sucesso => {
                atualizarEspecialidadesPaciente(id, especialidade);
                alert('Histórico cadastrado com sucesso!');
                
                this.props.history.push('/paciente/historico/' + this.state.id)
                // this.setState({
                //     loading: false,
                //     notifition: true,
                //     msg: 'Historico salvo com sucesso!',
                //     nameclass: "alert-success",
                //     downloadURLs: [], titulo: '', Observacao: '', 
                // })
            })
                .catch(erro => {
                    this.setState({ loading: false, notifition: true, msg: erro.code, nameclass: "alert-danger" })
                    window.scrollTo(0, 0);
                    this.setState({ loading: true })

                })

            if(this.props.onClose){
                this.props.onClose();
            }
        }else {
            this.setState({ loading: false })

            this.setState({ loading: false, notifition: true, msg: 'Favor selecionar uma especialidade', nameclass: "alert-danger" })
            window.scrollTo(0, 0)
        }

        


    }
    _setStatus = (value) => {

        this.setState({ status: value, notifition: false, msg: '', nameclass: "" })
        this.state.paciente.paciente.status = value

        Libfirebase
            .collection('paciente')
            .doc(this.state.paciente.id)
            .update({ status: value })
            .then(() => {
                this.setState({ notifition: true, msg: 'Status alterado com sucesso!', nameclass: "alert-success" })
            })
            .catch(error => {
                this.setState({ status: null, notifition: true, msg: 'Houve um erro ao salvar o status', nameclass: "alert-danger" })
            })
    }

    render() {
        return (
            <React.Fragment>
                <div className="">
                    {/* preloader */}
                    {this.props.loading && <Loader />}
    
                    <h4 className="card-title">Histórico</h4>
                    <h6 className="card-subtitle">Cadastre um histórico para o paciente</h6>
                    <form className="form-horizontal pt-2">

                        <DropDownEspecialidade especialidade={this.state.especialidade} change={event => this.setState({ especialidade: event.target.value })} />

                        <div className="row pt-2">
                            <div className="col-md-6">
                                <label className="control-label">Queixa Principal:</label>
                            </div>
                            <div className="col-md-6">
                                <div style={{ float: 'right' }}>
                                    <Popover>
                                        <button className="btn btn-light waves-effect waves-light" type="button"><span className="btn-label"><i className="fas fa-question"></i></span>Ajuda</button>
                                        <div>
                                            <b>Queixa principal (as) motivo de internamento</b> (nas próprias palavras do paciente)
                                        </div>
                                    </Popover>
                                </div>
                            </div>
                        </div>
                        <CKEditor
                            editor={ClassicEditor}
                            config={{
                                toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote']
                            }}
                            data={this.state.queixa}

                            onChange={(event, editor) => {
                                const data = editor.getData();
                                if (data !== this.state.queixa) {
                                    this.setState({ queixa: data })
                                }
                            }}
                        />
                        <div className="row pt-2">
                            <div className="col-md-6">
                                <label className="control-label">Historico da Moléstia Atual:</label>
                            </div>
                            <div className="col-md-6">
                                <div style={{ float: 'right' }}>
                                    <Popover>
                                        <button className="btn btn-light waves-effect waves-light" type="button"><span className="btn-label"><i className="fas fa-question"></i></span>Ajuda</button>
                                        <div>
                                            <b>História da doença actual (HDA)</b><br />
                                            Análise do sintoma principal:<br />
                                            Início, localização, tipo, intensidade, frequência, circunstância em que aparece (como), tempo especial de ocorrência, fatores agravante, fatores aliviantes, sintomas acompanhantes e medicamentos tomados!

                                        </div>
                                    </Popover>
                                </div>
                            </div>
                        </div>

                        <CKEditor
                            editor={ClassicEditor}
                            config={{
                                toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote']
                            }}
                            data={this.state.historico}
                            onInit={editor => {
                                // You can store the "editor" and use when it is needed.
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                if (data !== this.state.historico) {
                                    this.setState({ historico: data })
                                }
                            }}
                        />
                        <label className="control-label pt-2">Exames:</label>
                        <CKEditor
                            editor={ClassicEditor}
                            config={{
                                toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote']
                            }}
                            data={this.state.exames}

                            onChange={(event, editor) => {
                                const data = editor.getData();
                                if (data !== this.state.exames) {
                                    this.setState({ exames: data })
                                }
                            }}

                        />

                        <label className="control-label pt-2">Observação:</label>

                        <CKEditor
                            editor={ClassicEditor}
                            config={{
                                toolbar: ['bold', 'italic', 'bulletedList', 'numberedList', 'blockQuote']
                            }}
                            data={this.state.Observacao}

                            onChange={(event, editor) => {
                                const data = editor.getData();
                                if (data !== this.state.Observacao) {
                                    this.setState({ Observacao: data })
                                }
                            }}

                        />

                        <label className="control-label pt-2">Anexos:</label> <br />
                        <div className="col-sm-9">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <label className="gb-lbl-anexo">
                                        Escolher arquivos
                                        <FileUploader
                                            hidden
                                            accept="image/*"
                                            name="image-uploader-multiple"
                                            randomizeFilename
                                            storageRef={firebaseStorage.ref("images")}
                                            onUploadStart={this.handleUploadStart}
                                            onUploadError={this.handleUploadError}
                                            onUploadSuccess={this.handleUploadSuccess}
                                            onProgress={this.handleProgress}
                                            multiple
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p>Progresso: {this.state.uploadProgress}%</p>
                        <div className="row">
                            {this.state.downloadURLs.map((downloadURL, i) => {
                                return <div key={i} className="col-lg-3 col-sm-12">
                                    <a onClick={() => this.deleteFoto(downloadURL)} className="close">X</a>
                                    <img src={downloadURL} className="img-fluid" />
                                </div>;
                            })}
                        </div>
                        <br />
                        {this.state.notifition ?
                        <Notificacao msg={this.state.msg} nameclass={this.state.nameclass} />
                        : null}
                        <div className="form-group row m-b-0">
                            <div className="col-sm-12 text-center d-flex justify-content-center" style={{ textAlign: 'center' }}>
                                {this.state.loading ? (
                                    <center>
                                        <PreLoaderWidget ></PreLoaderWidget>
                                                salvando...
                                    </center>) :
                                    (
                                        <button type="button" onClick={() => this._setCadastro()} className="btn gb-button">Salvar</button>

                                    )}
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
}
